module.exports = __webpack_public_path__ + "images/1a8b3cd56500eba6634e7c4bf1d08f3c-IMG_0250.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/kitchen/IMG_0250.jpg
// module id = ./src/assets/images/slides/kitchen/IMG_0250.jpg
// module chunks = 0